import React from "react";
import { useSelector } from "react-redux";

import { Button } from "../../../helpers";

import "../index.css"

import moment from "moment";

import { getFullName, getProductName, getProductSpecification, getUOMStr } from "../../../utils";


const PunchedProducts = (props) =>{
    const { buyerPO, buyerPOItems, materialData, poPunch, poPunchItems, poPunchCreatedUsers, handlePOPunchDeleteClick} = props

    const brandData = useSelector((state) => state.common.materialBrands)

    const handlePOPunchDelete = (poPunchId) => {
        handlePOPunchDeleteClick(poPunchId)
    }

    return(
        <div className="punched-products-tab">
            <div className="flex flex-wrap py-2 w-full">
                <div className=" p-card flex justify-content-between align-items-center  flex-grow-1 font-bold pl-2 header-style bg-gray-200 header pb-2 mb-0" style={{ fontSize: "13px"}}>
                    <div className="" style={{ width: '8%' }}>Material Id</div>
                    <div className="" style={{ width: '15%' }}>Product</div>
                    <div className="" style={{ width: '30%' }}>Specifications</div>
                    <div className="" style={{ width: '5%' }}>Qty</div>
                    <div className="" style={{ width: '10%' }}>Ttl Punched Qty</div>
                    <div className="" style={{ width: '5%' }}>Delivery Period</div>
                    <div className="" style={{ width: '10%' }}>Expected Delivery Date</div>
                </div>
                {
                    poPunch.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map(eachPOPunch => {
                        const relatedPOPunchItems = poPunchItems?.filter(eachPOPunchItem => eachPOPunch.poPunchId === eachPOPunchItem.poPunchId)
                        let poPunchedUser = poPunchCreatedUsers?.find(eachUser => eachUser?.userId === eachPOPunch?.createdBy)
                        const poPunchedUserName = getFullName(poPunchedUser.firstName, poPunchedUser.lastName)
                        let poDocDate = moment(buyerPO?.poDocDate).format("DD/MM")
                        let poProcessedDate = moment(eachPOPunch?.poProcessedDate).format("DD/MM")
                        return (
                            <div className="w-full">
                                <div className="py-2 flex flex-row" style={{ width: '100%'}}>
                                    <div  className="flex align-items-center justify-content-between w-full ">
                                        <p className="m-0"><span className="text-green-600" style={{fontWeight: "bold"}}>{eachPOPunch?.poPunchId}</span> - <span style={{fontWeight: "600", fontSize: "12.5px"}} className="text-600">{buyerPO?.poDocDate && `Doc Date: ${poDocDate} - `} Processed Date: {poProcessedDate}</span></p>
                                        <p className="font-bold">Punched By: <span style={{ fontWeight: 'normal', fontSize: '1em' }}>{poPunchedUserName}</span> </p>
                                        <Button icon="pi pi-trash" rounded severity="danger" aria-label="Cancel" onClick={() => handlePOPunchDelete(eachPOPunch.poPunchId)} permissions={[193]} applyThrottle />
                                    </div>
                                </div>
                                <div className="p-card w-full px-0 pb-0 py-1 mb-2">
                                {
                                    relatedPOPunchItems?.map((eachPOPunchItem, index) => {
                                        const relatedBuyerPOItem = buyerPOItems?.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachPOPunchItem.buyerPOItemId)
                                        const relatedMaterialData = materialData?.find(eachMaterial => eachMaterial.materialId === relatedBuyerPOItem.materialId)
                                        const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === relatedMaterialData?.brandId)

                                        let productName = getProductName(relatedBrand?.brandName, relatedMaterialData?.productName, relatedMaterialData?.variantName) // relatedMaterialData?.companyProdName ? relatedMaterialData?.companyProdName : relatedMaterialData?.productName
                                        let productSpecification = getProductSpecification(relatedMaterialData?.productSpecification, relatedMaterialData.UOM, relatedMaterialData.UOMValue) // relatedMaterialData?.companyProdSpec ? relatedMaterialData?.companyProdSpec : relatedMaterialData?.productSpecification
                                        let expectedDeliveryDate = moment(eachPOPunchItem?.expectedDeliveryDate).format("DD/MM/YYYY")

                                        return (
                                            <div className="flex justify-content-between flex-grow-1 data-style align-items-center" style={{ fontSize: "13px"}}>
                                                <div className="py-2 px-2" style={{ width: '8%' }}>{relatedBuyerPOItem?.materialId}</div>
                                                <div className="py-2 px-2" style={{ width: '15%' }}>{productName}</div>
                                                <div className="py-2" style={{ width: '30%' }}>{productSpecification}</div>
                                                <div className="py-2" style={{ width: '5%' }}>{relatedBuyerPOItem?.bPOQty}</div>
                                                <div className="py-2" style={{ width: '10%' }}>{eachPOPunchItem?.punchQty}</div>
                                                <div className="py-2" style={{ width: '5%' }}>{relatedBuyerPOItem?.leadTime} days</div>
                                                <div className="py-2" style={{ width: '10%' }}>{expectedDeliveryDate}</div>
                                            </div>
                                        )
                                    })
                                }
                                
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default PunchedProducts;
